/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-11 16:05:53
 * @LastEditTime: 2024-09-26 20:02:25
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\userMaage\upPassword\index.tsx
 * @Description: 忘记密码页面
 */

import { CommmonPost } from "@/util/network/api";
import { Form, message } from "antd";
import { LgButton, LgInput } from "lancoo-web-ui";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserId, setLoginShow } from "../../../store/reducers/userInfo";
import { service } from "../data";
import PasswordIcon from '../images/密码.svg';

function UpPassword(props: any) {
  const {
    form,
    onLogin,
    setIsloading,
    phone,
    code
  } = props;

  const userId = useSelector(selectUserId);
  const dispatch = useDispatch();

  const submit = () => {
    form.validateFields().then((values) => {
      setIsloading(true);

      CommmonPost(service.resetPasswordByPhone, {
        password: values.password,
        code,
        phone
      }).then((res) => {
        message.success("修改密码成功");
        if (userId) {
          dispatch(setLoginShow(false));
        } else {
          onLogin();
        }
      }).catch((error) => {
        console.log(error);
        if (error.msg) {
          message.warning(error.msg, 2);
        } else {
          message.warning('修改密码失败', 2);
        }
      })
    }).catch(error => {
      console.log(error);
    }).finally(() => {
      setIsloading(false);
    });
  }

  useEffect(() => {
    const formData = form.getFieldsValue();
    form.setFieldsValue({
      ...formData,
      password: '',
      confirmPwd: ''
    });
  }, []);

  return (
    <>
      <Form.Item
        style={{ position: 'relative', marginBottom: 0 }}
        className='form_icon'
      >
        <div className='form_icon_div' style={{ background: `url(${PasswordIcon}) no-repeat center` }} />
        <Form.Item
          name="password"
          rules={[{ required: true, message: '请输入密码!' }]}
          style={{ marginBottom: 16 }}
        >
          <LgInput
            bigWidth
            maxLength={20}
            input={{ placeholder: "请输入新密码(长度在6-20位之间)", type: 'password' }}
            size='oversized'
            style={{ height: 48 }}
          />
        </Form.Item>
      </Form.Item>
      <Form.Item
        style={{ position: 'relative', marginBottom: 0 }}
        className='form_icon'
      >
        <div className='form_icon_div' style={{ background: `url(${PasswordIcon}) no-repeat center` }} />
        <Form.Item
          name="confirmPwd"
          rules={[{ required: true, message: '请再次输入密码!' }]}
          style={{ marginBottom: 16 }}
        >
          <LgInput
            bigWidth
            input={{ placeholder: "请再次确认密码(长度在6-20位之间)", type: 'password' }}
            size='oversized'
            style={{ height: 48 }}
          />
        </Form.Item>
      </Form.Item>

      <Form.Item style={{ marginBottom: 22 }}>
        <LgButton
          onClick={submit}
          backgroundType='opacification'
          type='info'
          size='super'
          style={{ justifyContent: 'center', width: 360 }}
        >
          确认
        </LgButton>
      </Form.Item>
    </>
  )
}

export default UpPassword
